import {getAgent} from '@kakao/agent';
import {PHASE} from '@src/constants';

// TODO: 환경 변수는 항상 string이므로 'undefined' 케이스 처리 필요
export const getCurrentPhase = (): string => process.env.NEXT_PUBLIC_PHASE ?? '';
export const isSandbox = (): boolean => getCurrentPhase() === PHASE.SANDBOX;
export const isProd = (): boolean => getCurrentPhase() === PHASE.PRODUCTION;

export const existWindow = (): boolean => typeof window !== 'undefined';
export const getWindow = (): Window | any => (existWindow() ? window : {});

export const isIOS = (): boolean => existWindow() && getAgent().isIOS;
export const isAndroid = (): boolean => existWindow() && getAgent().isAndroid;
export const isKakaoTalk = (): boolean => existWindow() && getAgent().isKakaoTalk;
export const isDesktop = (): boolean => existWindow() && getAgent().isDesktop;

export const objToSearch = (params: {[key: string]: any}) => {
  const querystring = Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  return querystring ? `?${querystring}` : '';
};

const MONTH_RANGE = {MIN: 1, MAX: 12};
const YEAR_RANGE = {MIN: 1992, MAX: 2100};

export const getYearMonthFromQuery = ({year, month}: any) => {
  const now = new Date();
  const yearMonth = {year: now.getFullYear(), month: now.getMonth() + 1};
  if (isNaN(Number(year)) || isNaN(Number(month))) {
    return yearMonth;
  }
  if (Number(month) < MONTH_RANGE.MIN || Number(month) > MONTH_RANGE.MAX) {
    return yearMonth;
  }
  if (Number(year) < YEAR_RANGE.MIN || Number(year) > YEAR_RANGE.MAX) {
    return yearMonth;
  }
  return {year: Number(year), month: Number(month)};
};

function camelStringToSnake (str: string, isUpperCase?: boolean) {
  let result = '';

  if (str !== undefined && str !== null) {
    const sp = str.split(/(?=[A-Z])/);
    if (isUpperCase !== undefined && isUpperCase !== null && isUpperCase) {
      result = sp.join('_').toUpperCase();
    } else {
      result = sp.join('_').toLowerCase();
    }
  }
  return result;
}

export function camelObjectToSnake (obj: Record<string, any>) {
  const result: Record<string, any> = {};
  const keys = Object.keys(obj);

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    result[camelStringToSnake(key)] = obj[key];
  }
  return result;
}

export function splitPaginationData<T = any> (data: T[][], page: number, index: number) {
  const prev = data.slice(0, page + 1).map((item, prevPage) => (page === prevPage ? item.slice(0, index) : [...item]));
  const next = data
    .slice(page, data.length)
    .map((item, nextPage) => (nextPage === 0 ? item.slice(index, item.length) : [...item]));
  return [prev, next];
}
